/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { AlarmCodeContext } from '@/providers/AlarmCodeContext'

const useAlarmCodes = () => {
  const codes = React.useContext(AlarmCodeContext)
  return codes
}
export default useAlarmCodes
